/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promos_TitleInputs */



/**
* | output |
* | --- |
* | "Promo Cards Distributed" |
*
* @param {Promos_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_title = /** @type {((inputs?: Promos_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cartes promo distribuées")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cartas promo distribuidas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cartas promo distribuídas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carte promo distribuite")
	return /** @type {LocalizedString} */ ("Promo Cards Distributed")
});